import classNames from 'classnames';
import React from 'react';
import '../../styles/list-select-field.scss';
import { createField, noop } from '../helpers';
import { FieldFactoryProps, JsxSelectOption, SelectValue } from '../types';

interface FFProps<Value extends SelectValue>
    extends FieldFactoryProps<Value, HTMLDivElement>, ExtraProps<Value> { }

interface ExtraProps<Value extends SelectValue> {
    /**
     * List of possible values
     */
    options?: Array<JsxSelectOption<Value>>;
    /**
     * Override default tabIndex (0)
     */
    tabIndex?: number;
}

/**
 * Displays a list of selectable options in a list.
 *
 * @todo Add keyboard support
 */
const ListSelectField = createField<
    SelectValue,
    HTMLDivElement,
    {
        /**
         * List of possible values
         */
        options?: Array<JsxSelectOption<SelectValue>>;
        /**
         * Override default tabIndex (0)
         */
        tabIndex?: number;
    }
>(<Value extends SelectValue>({
    className,
    name = null,
    onValueChange = noop,
    options = [],
    tabIndex = 0,
    value = null,
    Renderer, error, label, // Props we don't want to pass along
    ...props
}: FFProps<Value>) => <div
        className={`form-control list-select-field ${className}`}
        tabIndex={tabIndex !== null ? tabIndex : undefined}
        {...props}>
    {options && options.map(({value: val, label: subLabel}) =>
        <div key={val} className={classNames(
                'list-select-field-option',
                {selected: val === value}
            )}
            onClick={(e) => onValueChange(val, value, name, e)}
        >{subLabel}</div>
    )}
</div>);

export default ListSelectField;
